'use strict';

function EmailToTaskEditCtrl(
  $scope,
  $state,
  $stateParams,
  $translate,
  categories,
  growl,
  emailToTask,
  CompanySettingUnitsService
  ) {
  $scope.emailToTask = emailToTask;
  $scope.categories = categories;
  $scope.filterUnits = $scope.emailToTask.unit ? $scope.emailToTask.unit.name : "";
  $scope.saveTask = function() {
    $scope.emailToTask.$update({
      companyId: $stateParams.companyId,
      emailToTaskId: $stateParams.emailToTaskId
    }, function(){
      growl.addSuccessMessage($translate.instant('email-to-task.save-success'));
      $state.go('root.company.account.email-to-task.list');
    }, function(){
      growl.addErrorMessage($translate.instant('email-to-task.save-failure'));
    });
  };

  $scope.addAssignee = function(assignee) {
    $scope.emailToTask.assignees.push(assignee);
    angular.element('#filterAssignees').val('');
  };

  $scope.addedAssignees = function(assignee) {
    return ($scope.emailToTask.assignees.indexOf(assignee) === -1);
  };

  $scope.removeAssignee = function(assignee) {
    $scope.emailToTask.assignees.splice($scope.emailToTask.assignees.indexOf(assignee), 1);
  };

  $scope.searchUnits = function(filter) {
    CompanySettingUnitsService.query({companyId: $scope.companyId, limit: 10, q: filter}).$promise.then(function(units) {
      return units.filter(function(item) {
        return !$scope.emailToTask.unit || ($scope.emailToTask.unit && item.id !== $scope.emailToTask.unit.id);
      });
    }).then(function(nonUnits) {
      $scope.units = nonUnits;
    });
  };
}

EmailToTaskEditCtrl.resolve = {
  emailToTask: ['EmailToTaskService', '$stateParams', function(EmailToTaskService, $stateParams){
    return EmailToTaskService.get({
      companyId: $stateParams.companyId,
      emailToTaskId: $stateParams.emailToTaskId
    }).$promise;
  }],
  categories: ['$stateParams', 'CompanyTaskService', function ($stateParams, CompanyTaskService) {
    return CompanyTaskService.queryCategories({
      companyId: $stateParams.companyId,
      all: true
    }).$promise;
  }]
};

module.exports = EmailToTaskEditCtrl;

angular.module('dokiv')
  .controller('EmailToTaskEditCtrl', [
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'categories',
    'growl',
    'emailToTask',
    'CompanySettingUnitsService',
    EmailToTaskEditCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-task/EmailToTaskEditCtrl.js
// module id = 347
// module chunks = 0